import { ActivityStateIndicator } from '@/modules/activity-state/components/activity-state-indicator.tsx'
import { getActivityStateById } from '@/modules/activity-state/utils.ts'
import { useTeamActivityStates } from '@/modules/team/hooks/use-team-activity-states.tsx'

export const LiveTeamActivityState = ({ id }: { id: number }) => {
  const { activityStates, isLoading } = useTeamActivityStates()

  if (isLoading || activityStates === undefined) {
    return null
  }

  return (
    <div className="absolute -bottom-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-card">
      <ActivityStateIndicator
        state={getActivityStateById(activityStates, id)}
      />
    </div>
  )
}
